import { createStore, applyMiddleware, compose, Middleware, Store } from "redux";
import createRootReducer, { IRootState } from "./reducers";
import createSagaMiddleware, { END, Task } from "redux-saga";
import { createLogger } from "redux-logger";
import rootSaga from "~/store/root-saga";

export interface IStore extends Store<IRootState | undefined> {
    runSaga: (saga: any) => Task;
    close: () => END;
}

let middleWares: Middleware[] = [];
const sagaMiddleware = createSagaMiddleware();
middleWares = middleWares.concat(sagaMiddleware);

if (process.env.NODE_ENV === "development") {
    middleWares = middleWares.concat(createLogger());
}

function configureStore(initialState?: IRootState) {
    let composeEnhancers = compose;

    if (typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__) {
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }

    const reduxStore = createStore(
        createRootReducer(),
        initialState,
        composeEnhancers(applyMiddleware(...middleWares))
    );

    const newStore: IStore = {
        ...reduxStore,
        runSaga: sagaMiddleware.run,
        close: () => newStore.dispatch(END)
    };

    newStore.runSaga(rootSaga);

    return newStore;
}

export const store = configureStore();
